import type { IShareIconProps } from './helpers';

export const ShareIcon = ({ variant = 'default', ...rest }: IShareIconProps) => {
	if (variant === 'button')
		return (
			<svg
				width='14'
				height='14'
				viewBox='0 0 14 14'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g clipPath='url(#clip0_11316_71816)'>
					<path
						d='M4.8524 6.68665L4.43262 5.98168L9.12858 3.16016L9.54836 3.86511L4.8524 6.68665Z'
						fill='#05A2BF'
					/>
					<path
						d='M9.08547 10.9821L4.56055 8.66971L4.93064 7.9375L9.4556 10.25L9.08547 10.9821Z'
						fill='#05A2BF'
					/>
					<path
						d='M11.1016 0C9.74802 0 8.64062 1.10739 8.64062 2.46094C8.64062 3.81443 9.74802 4.92188 11.1016 4.92188C12.4551 4.92188 13.5625 3.81443 13.5625 2.46094C13.5625 1.10739 12.4551 0 11.1016 0Z'
						fill='#05A2BF'
					/>
					<path
						d='M11.1016 9.07812C9.74802 9.07812 8.64062 10.1855 8.64062 11.5391C8.64062 12.8926 9.74802 14 11.1016 14C12.4551 14 13.5625 12.8926 13.5625 11.5391C13.5625 10.1855 12.4551 9.07812 11.1016 9.07812Z'
						fill='#05A2BF'
					/>
					<path
						d='M2.89844 4.94922C1.54489 4.94922 0.4375 6.05661 0.4375 7.41016C0.4375 8.76364 1.54489 9.87109 2.89844 9.87109C4.25198 9.87109 5.35938 8.76364 5.35938 7.41016C5.35938 6.05661 4.25198 4.94922 2.89844 4.94922Z'
						fill='#05A2BF'
					/>
					<path
						d='M13.5625 11.5391C13.5625 12.8926 12.4551 14 11.1016 14V9.07812C12.4551 9.07812 13.5625 10.1855 13.5625 11.5391Z'
						fill='#05A2BF'
					/>
					<path
						d='M11.1006 4.92188V0C12.4541 0 13.5615 1.10739 13.5615 2.46094C13.5615 3.81443 12.4541 4.92188 11.1006 4.92188Z'
						fill='#05A2BF'
					/>
					<path
						d='M5.35938 7.41016C5.35938 8.76364 4.25198 9.87109 2.89844 9.87109V4.94922C4.25198 4.94922 5.35938 6.05661 5.35938 7.41016Z'
						fill='#05A2BF'
					/>
				</g>
				<defs>
					<clipPath id='clip0_11316_71816'>
						<rect
							width='14'
							height='14'
							fill='white'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	return (
		<svg
			width='41'
			height='41'
			viewBox='0 0 41 41'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				x='0.5'
				y='0.5'
				width='40'
				height='40'
				rx='20'
				fill='#CDECF2'
			/>
			<g clipPath='url(#clip0_10751_196354)'>
				<path
					d='M17.9909 20.1371L17.5005 19.3135L22.9868 16.0171L23.4772 16.8407L17.9909 20.1371Z'
					fill='#022745'
				/>
				<path
					d='M22.9364 25.1523L17.6499 22.4507L18.0823 21.5952L23.3688 24.2969L22.9364 25.1523Z'
					fill='#022745'
				/>
				<path
					d='M25.2916 12.3218C23.7103 12.3218 22.4165 13.6156 22.4165 15.1969C22.4165 16.7782 23.7103 18.072 25.2916 18.072C26.873 18.072 28.1667 16.7782 28.1667 15.1969C28.1667 13.6156 26.873 12.3218 25.2916 12.3218Z'
					fill='#022745'
					fillOpacity='0.4'
				/>
				<path
					d='M25.2916 22.9233C23.7103 22.9233 22.4165 24.2171 22.4165 25.7985C22.4165 27.3797 23.7103 28.6736 25.2916 28.6736C26.873 28.6736 28.1667 27.3797 28.1667 25.7985C28.1667 24.2171 26.873 22.9233 25.2916 22.9233Z'
					fill='#022745'
					fillOpacity='0.4'
				/>
				<path
					d='M15.7079 18.103C14.1265 18.103 12.8328 19.3968 12.8328 20.9781C12.8328 22.5594 14.1265 23.8533 15.7079 23.8533C17.2892 23.8533 18.583 22.5594 18.583 20.9781C18.583 19.3968 17.2892 18.103 15.7079 18.103Z'
					fill='#022745'
					fillOpacity='0.4'
				/>
				<path
					d='M28.1669 25.7985C28.1669 27.3797 26.8731 28.6736 25.2917 28.6736V22.9233C26.8731 22.9233 28.1669 24.2171 28.1669 25.7985Z'
					fill='#022745'
				/>
				<path
					d='M25.2915 18.072V12.3218C26.8729 12.3218 28.1666 13.6156 28.1666 15.1969C28.1666 16.7782 26.8729 18.072 25.2915 18.072Z'
					fill='#022745'
				/>
				<path
					d='M18.5831 20.9781C18.5831 22.5594 17.2894 23.8533 15.708 23.8533V18.103C17.2894 18.103 18.5831 19.3968 18.5831 20.9781Z'
					fill='#022745'
				/>
			</g>
			<defs>
				<clipPath id='clip0_10751_196354'>
					<rect
						width='16.3562'
						height='16.3562'
						fill='white'
						transform='translate(12.3218 12.3218)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
